// صورتحساب آب، برق، تلفن و ... (قبوض یک اشتراک)
import React, { useState, useEffect, useCallback } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, Grid, Field, Lookup, MessageBox, ChoiceBox, splitLines, visibleCols, runReport, num, fmtAmt,
} from './BuildingsShared';

const FORM = 'FRMBUILDINGFACILITIESBILL';
const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL', 'BTNNEWREQUEST',
  'BTNBUILDINGFACILITIESREQUEST', 'BTNBUILDINGFACILITIESCONFIRM'];

export const BILL_COLS = [
  { key: 'asker', label: 'درخواست کننده', wrap: true },
  { key: 'department', label: 'واحد اجرایی', wrap: true },
  { key: 'amount_receiver', label: 'گیرنده وجه', wrap: true },
  { key: 'from_date', label: 'ازتاریخ' },
  { key: 'to_date', label: 'تاتاریخ' },
  { key: 'bill_amount', label: 'مبلغ صورتحساب', money: true },
  { key: 'bill_round', label: 'رُند هزار ریال', money: true },
  { key: 'amount', label: 'مبلغ', money: true },
  { key: 'added_tax', label: 'مالیات بر ارزش افزوده', money: true },
  { key: 'debit_before', label: 'بدهی قبلی', money: true },
  { key: 'bill_id', label: 'شناسه قبض' },
  { key: 'slip_id', label: 'شناسه پرداخت', wrap: true },
  { key: 'consumption', label: 'مقدار مصرف' },
  { key: 'consumption_unit', label: 'واحد مصرف' },
  { key: 'consumption_day', label: 'تعداد روز' },
  { key: 'remark', label: 'شرح', wrap: true },
  { key: 'request_no', label: 'شماره درخواست', num: true },
  { key: 'request_date', label: 'تاریخ درخواست' },
  { key: 'confirm_no', label: 'شماره تایید', num: true },
  { key: 'confirm_date', label: 'تاریخ تایید' },
  { key: 'hazineh_document_no', label: 'شماره سندهزینه', num: true },
  { key: 'hazineh_document_date', label: 'تاریخ سندهزینه' },
  { key: 'user_group', label: 'گروه کاربری' },
];

const KEYS = ['asker_id', 'asker', 'department_id', 'department', 'amount_receiver_id', 'amount_receiver',
  'from_date', 'to_date', 'bill_amount', 'bill_round', 'added_tax', 'debit_before', 'bill_id', 'slip_id',
  'consumption', 'consumption_unit', 'consumption_day', 'remark', 'request_no', 'request_date',
  'confirm_no', 'confirm_date', 'hazineh_document_no', 'hazineh_document_date'];
const pick = r => KEYS.reduce((o, k) => ({ ...o, [k]: r ? (r[k] ?? '') : '' }), {});

function Box({ title, children }) {
  return (
    <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '6px 10px', flex: 1, minWidth: '220px' }}>
      <div style={ui.flabel}>{title}</div>
      <div style={{ display: 'flex', gap: '8px' }}>{children}</div>
    </div>
  );
}

function DateField({ label, value, onChange }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: '130px' }}>
      <label style={ui.mlabel}>{label}</label>
      <JalaliDatePicker value={value} onChange={onChange} placeholder={label} />
    </div>
  );
}

export default function BuildingFacilitiesBill({ user, onBack, facility, title, year }) {
  const fb = useFormButtons(FORM, BUTTONS);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(pick(null));
  const [formErr, setFormErr] = useState('');
  const [newReq, setNewReq] = useState(false);
  const [msg, setMsg] = useState(null);
  const [ask, setAsk] = useState(null);
  const [choice, setChoice] = useState(false);

  const load = useCallback(async (keepId) => {
    setLoading(true); setError('');
    const j = await API(`/facilities/${facility.id}/bills/`);
    setLoading(false);
    if (!j.ok) { setError(j.msg); return; }
    setRows(j.data);
    const hit = keepId ? j.data.find(r => r.id === keepId) : null;
    setSelected(hit || j.data[0] || null);
  }, [facility]);

  useEffect(() => { if (fb.loaded && fb.open) load(); }, [fb.loaded, fb.open]);

  const showMsg = m => setMsg(splitLines(m));
  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const has = !!selected;
  const amount = num(form.bill_amount) + num(form.bill_round);

  const openNew = async () => {
    const j = await API(`/facilities/${facility.id}/bills/defaults/?year=${year}`);
    if (!j.ok) { showMsg(j.msg); return; }
    const d = j.data;
    const s = selected || {};
    setForm({
      ...pick(null),
      asker_id: s.asker_id || d.asker_id, asker: s.asker_id ? s.asker : d.asker,
      department_id: s.department_id || d.department_id, department: s.department_id ? s.department : d.department,
      amount_receiver_id: s.amount_receiver_id || d.amount_receiver_id,
      amount_receiver: s.amount_receiver_id ? s.amount_receiver : d.amount_receiver,
      slip_id: s.slip_id || '', from_date: d.from_date || '',
      request_no: d.request_no, request_date: d.request_date, confirm_no: d.confirm_no, confirm_date: d.confirm_date,
    });
    setFormErr(''); setNewReq(true); setModal('new');
    if (j.messages && j.messages.length) showMsg(j.messages.join('\n'));
  };
  const openEdit = async () => {
    if (!selected) return;
    const j = await API(`/bills/${selected.id}/check-edit/`);
    if (!j.ok) { showMsg(j.msg); return; }
    setForm(pick(selected)); setFormErr(''); setNewReq(false); setModal('edit');
  };
  const save = async () => {
    setFormErr('');
    const body = JSON.stringify({ ...form, facility_id: facility.id, year });
    const j = modal === 'new'
      ? await API('/bills/create/', { method: 'POST', body })
      : await API(`/bills/${selected.id}/update/`, { method: 'PUT', body });
    if (j.ok) {
      setModal(null); load(j.id);
      if (j.messages && j.messages.length) showMsg(j.messages.join('\n'));
    } else {
      setFormErr(j.msg);
      if (j.need_new_request) setNewReq(true);
    }
  };
  const newRequestNo = async () => {
    const j = await API(`/request-no/?year=${year}&request_date=${encodeURIComponent(form.request_date || '')}&confirm_date=${encodeURIComponent(form.confirm_date || '')}`);
    if (!j.ok) { showMsg(j.msg); return; }
    setForm(f => ({ ...f, request_no: j.request_no, confirm_no: j.confirm_no }));
    if (j.messages && j.messages.length) showMsg(j.messages.join('\n'));
  };
  const taxKey = e => {
    if (e.key === 'F11') {
      e.preventDefault();
      const p = num(form.added_tax);
      if (p <= 100) F('added_tax', String(Math.round(amount * p / 100)));
    }
  };
  const doDelete = async () => {
    setAsk(null);
    const j = await API(`/bills/${selected.id}/delete/`, { method: 'DELETE' });
    if (j.ok) load(); else showMsg(j.msg);
  };

  const shown = visibleCols(BILL_COLS, rows);
  const toolbar = (
    <>
      {fb.open && (
        <div style={ui.toolBtns}>
          {fb.can('BTNNEW') && <button onClick={openNew} style={{ ...ui.btnNew, cursor: 'pointer' }}>＋ جدید</button>}
          {fb.can('BTNEDIT') && rows.length > 0 && <button onClick={openEdit} disabled={!has} style={{ ...ui.btnEdit, cursor: 'pointer' }}>✎ ویرایش</button>}
          {fb.can('BTNDELETE') && rows.length > 0 && <button onClick={() => has && setAsk(true)} disabled={!has} style={{ ...ui.btnDel, cursor: 'pointer' }}>✕ حذف</button>}
          {fb.can('BTNBUILDINGFACILITIESREQUEST') && has && (
            <button onClick={() => runReport('tadarokat.building_bill_request',
              { request_no: selected.request_no, request_date: selected.request_date }, showMsg)}
            style={{ ...ui.btnItems, cursor: 'pointer' }}>برگه درخواست</button>)}
          {fb.can('BTNBUILDINGFACILITIESCONFIRM') && has && (
            <button onClick={() => setChoice(true)} style={{ ...ui.btnItems, cursor: 'pointer' }}>تاییدیه</button>)}
        </div>
      )}
      <ExcelButton title={title || 'صورتحساب آب، برق، تلفن و ...'} columns={shown} rows={rows} />
    </>
  );

  return (
    <>
      <ListPage user={user} onBack={onBack} title={title || 'صورتحساب آب، برق، تلفن و ...'}
        subtitle="تدارکات — سامانه ارجان" toolbar={toolbar} error={error} loading={loading}>
        <Grid columns={shown} rows={rows} selectedId={selected && selected.id} onSelect={setSelected}
          loading={loading} empty="قبضی ثبت نشده است" />
      </ListPage>

      {modal && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '900px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? 'صورتحساب جدید' : 'ویرایش صورتحساب'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {formErr && <div style={{ ...ui.errBox, whiteSpace: 'pre-line' }}>⚠️ {formErr}</div>}
              <div style={ui.row}>
                <DateField label="تاریخ: از" value={form.from_date} onChange={v => F('from_date', v)} />
                <DateField label="تا" value={form.to_date} onChange={v => F('to_date', v)} />
                <Field label="شناسه قبض" value={form.bill_id} onChange={v => F('bill_id', v)} ltr />
                <Field label="شناسه پرداخت" value={form.slip_id} onChange={v => F('slip_id', v)} ltr />
              </div>
              <div style={ui.row}>
                <Field label="مبلغ صورتحساب" value={form.bill_amount} onChange={v => F('bill_amount', v)} ltr />
                <Field label="رُند هزار ریال" value={form.bill_round} onChange={v => F('bill_round', v)} ltr />
                <Field label="مبلغ" value={fmtAmt(amount)} disabled />
                <Field label="مالیات بر ارزش افزوده" value={form.added_tax} onChange={v => F('added_tax', v)} onKeyDown={taxKey} ltr />
                <Field label="بدهی قبلی" value={form.debit_before} onChange={v => F('debit_before', v)} ltr />
              </div>
              <div style={ui.row}>
                <Field label="مقدار مصرف" value={form.consumption} onChange={v => F('consumption', v)} />
                <Field label="واحد مصرف" value={form.consumption_unit} onChange={v => F('consumption_unit', v)} />
                <Field label="تعداد روز" value={form.consumption_day} onChange={v => F('consumption_day', v)} />
              </div>
              <div style={ui.row}>
                <Field label="شرح" value={form.remark} onChange={v => F('remark', v)} />
              </div>
              <div style={ui.row}>
                <Lookup label="درخواست کننده" value={form.asker} endpoint="/lookup/people/"
                  onPick={r => setForm(f => ({ ...f, asker_id: r.id, asker: r.title }))} />
                <Lookup label="واحد اجرایی" value={form.department} endpoint="/lookup/departments/"
                  onPick={r => setForm(f => ({ ...f, department_id: r.id, department: r.title }))} />
                <Lookup label="گیرنده وجه" value={form.amount_receiver} endpoint="/lookup/amount-receivers/"
                  onPick={r => setForm(f => ({ ...f, amount_receiver_id: r.id, amount_receiver: r.title }))} />
              </div>
              <div style={ui.row}>
                <Box title="درخواست">
                  <Field label="شماره" value={form.request_no} onChange={v => F('request_no', v)} ltr />
                  <DateField label="تاریخ" value={form.request_date} onChange={v => F('request_date', v)} />
                </Box>
                <Box title="تایید">
                  <Field label="شماره" value={form.confirm_no} onChange={v => F('confirm_no', v)} ltr />
                  <DateField label="تاریخ" value={form.confirm_date} onChange={v => F('confirm_date', v)} />
                </Box>
                <Box title="سند هزینه">
                  <Field label="شماره" value={form.hazineh_document_no || ''} disabled />
                  <Field label="تاریخ" value={form.hazineh_document_date || ''} disabled />
                </Box>
              </div>
            </div>
            <div style={ui.mFooter}>
              {newReq && fb.can('BTNOK') && <button onClick={newRequestNo} style={{ ...ui.btnItems, cursor: 'pointer' }}>شماره درخواست جدید</button>}
              {fb.can('BTNCANCEL') && <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>}
              {fb.can('BTNOK') && <button onClick={save} style={ui.btnSave}>ثبت</button>}
            </div>
          </div>
        </div>
      )}

      {choice && <ChoiceBox options={['صورتجلسه مصرف', 'تاییدیه']} onCancel={() => setChoice(false)}
        onPick={o => { setChoice(false); runReport('tadarokat.building_bill_confirm', { confirm_no: selected.confirm_no,
          confirm_date: selected.confirm_date, request_date: selected.request_date, is_confirm: o === 'تاییدیه' ? 1 : 0 }, showMsg); }} />}
      {ask && <WarningDialog title="هشدار" lines={['آيا از حذف اين رکورد مطمئن هستيد؟']} confirmLabel="بلی" cancelLabel="خیر"
        onConfirm={doDelete} onCancel={() => setAsk(null)} tone="danger" />}
      {msg && <MessageBox lines={msg} onClose={() => setMsg(null)} />}
    </>
  );
}
